import { Box, Button } from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import React, { useEffect, useState } from "react";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ChipJobDetails from "../Components/ChipJobDetails";
import { useApidashboardMutation } from "../Store/Middleware/api/dashboardAPI";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import { useApijobapplyMutation } from "../Store/Middleware/api/jobApplyAPI";
import moment from "moment";
import { toast } from "react-toastify";
import WorkIcon from "@mui/icons-material/Work";
import ShareIcon from "@mui/icons-material/Share";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from "@mui/icons-material/People";
import SignupPopup from "../Components/SignupPopup";
import OtpVerify from "../Components/OtpVerify";
import ResumeUpload from "../Components/ResumeUpload";
import ConfirmModal from "../Components/ConfirmModal";
import SourceIcon from "@mui/icons-material/Source";
import { Tooltip } from "@mui/material";
import ShareUI from "../Components/ShareUI";

function getDate(date) {
  const beforeDate = new Date(`${date}`);
  const today = new Date();
  const diffTime = Math.abs(today - beforeDate);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

function Html(htmlString) {
  const containsEscapeCharacters = /&lt;|&gt;/.test(htmlString);
  const processedHtmlString = containsEscapeCharacters
    ? unescapeHtmlEntities(htmlString)
    : htmlString;
  return processedHtmlString;
}
function unescapeHtmlEntities(text) {
  var doc = new DOMParser().parseFromString(text, "text/html");
  return doc.documentElement.textContent;
}

const Jobdetails = () => {
  const { id } = useParams();
  const [isShow, setShow] = useState(false);
  const [skills, setSkills] = useState([]);
  const [responseData, setResponseData] = useState();
  const [isApplied, setIsApplied] = useState({
    applied: false,
    applied_date: "",
    applied_date_hire: "",
  });
  const [apiDashboard, result] = useApidashboardMutation();
  const [referData, setReferData] = useState(null);
  const [apiJodApply, Jobresult] = useApijobapplyMutation();
  const [isOpen, setIsOpen] = useState({
    isSignupOpen: false,
    isOTPOpen: false,
    isResumeOpen: false,
    isAvatarOpen: false,
    hamburgerMenuOpen: false,
    isConfirm: false,
  });
  const [token, setToken] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllData();
    document.title = "Job Details | Career Portal";
  }, []);

  // useEffect
  useEffect(() => {
    if (
      localStorage.getItem("loginUrl") === `/authPage/jobdetails/${id}` &&
      Cookies.get("authToken") &&
      referData === false
    ) {
      setIsOpen((prev) => ({ ...prev, isConfirm: true }));
      localStorage.removeItem("loginUrl");
    }
  }, [referData]);

  const getAllData = async () => {
    const response = await apiDashboard({
      jdid: Number(id),
      token: Cookies.get("authToken"),
      page: 1,
    });
    if (response?.data?.success) {
      setIsApplied({
        applied: response?.data?.message?.job_applied,
        applied_date: response?.data?.message?.applied_date,
        applied_date_hire: response?.data?.message?.applied_date_hire,
      });
      if (response?.status === 401) {
        localStorage.clear();
        Cookies.remove("_secure_ARJ_");
        window.location.href = "/login";
      }
      setSkills(response?.data?.message?.skills);
      setResponseData(response?.data?.message?.dashboard[0]);
      setReferData(response?.data?.message?.applicants);
    }
  };

  const handleApplyJob = async () => {
    if (Cookies.get("authToken")) {
      setIsOpen((prev) => ({
        ...prev,
        isConfirm: !isOpen.isConfirm,
      }));
    } else {
      // toast.error("Please Login First");
      setIsOpen((prev) => ({
        ...prev,
        isSignupOpen: !isOpen.isSignupOpen,
        hamburgerMenuOpen: !isOpen.hamburgerMenuOpen,
      }));
      localStorage.setItem("loginUrl", `/authPage/jobdetails/${id}`);
    }
  };

  const handleShareJob = () => {
    // navigator.clipboard.writeText(window.location.href);
    // toast.success("Link Copied");
    setShow(true);
  };

  return (
    <>
      <div className="jobDetailsPage">
        <div className="jobDetailWrapper">
          <div className="jobDetailCard">
            <div className="basicDetailsWrapper">
              <div className="basicDetailsContentWrapper">
                {responseData?.logo === "no logo" ? (
                  <Box
                    sx={{
                      width: "80px",
                      height: "80px",
                      display: "grid",
                      placeItems: "center",
                      borderRadius: 2,
                      border: "1px solid rgba(0, 0, 0, 0.10)",
                    }}
                  >
                    <WorkIcon sx={{ color: "#D3D3D3", fontSize: "48px" }} />
                  </Box>
                ) : (
                  <img src={responseData?.logo} className="jobdetailsImg" />
                )}

                <div>
                  <div className="basicDetailTitle">
                    {responseData?.title?.charAt(0)?.toUpperCase() +
                      responseData?.title?.slice(1) || "NA"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      columnGap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnOutlinedIcon
                      fontSize="small"
                      style={{ color: "#424242" }}
                    />
                    <div className="jobdetailsMain-b2-m2">
                      {responseData?.city || "N/A"},{" "}
                      {responseData?.state || "N/A"}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      columnGap: "8px",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                      paddingTop: "0.5rem",
                    }}
                  >
                    <AccessTimeOutlinedIcon
                      fontSize="small"
                      style={{ color: "#424242" }}
                    />
                    <div className="jobdetailsMain-b2-m2">
                      {(() => {
                        if (getDate(responseData?.approvedDate) <= 1) {
                          return "Few hours ago";
                        } else {
                          return `${
                            getDate(responseData?.approvedDate) > 1
                              ? getDate(responseData?.approvedDate) > 60
                                ? "60"
                                : getDate(responseData?.approvedDate) - 1
                              : getDate(responseData?.approvedDate)
                          } days ago`;
                        }
                      })()}{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div className="applyWrapper">
                <div className="shareWrapper" onClick={handleShareJob}>
                  <span
                    className="shareText"
                    style={{
                      color: "#7eaaff",
                    }}
                  >
                    Share this Job
                  </span>
                  <ShareIcon sx={{ color: "#7eaaff", cursor: "pointer" }} />
                </div>
                {/* <div style={{ color: "black" }}>
                  {" "}
                  {getDate(isApplied.applied_date)}
                </div> */}

                {(getDate(isApplied.applied_date) ||
                  getDate(isApplied.applied_date_hire)) &&
                (getDate(isApplied.applied_date) < 90 ||
                  getDate(isApplied.applied_date_hire) < 90) ? (
                  <div style={{ color: "black", whiteSpace: "nowrap" }}>
                    Applied on{" "}
                    {moment(
                      isApplied.applied_date ?? isApplied.applied_date_hire,
                    ).format("DD/MM/YYYY")}
                  </div>
                ) : (
                  <Button
                    variant="contained"
                    sx={{
                      background: "#165DFF",
                      position: "unset",
                      "&:hover": {
                        background: "#165DFF",
                      },
                    }}
                    onClick={handleApplyJob}
                    disabled={Jobresult.isLoading}
                  >
                    Apply
                  </Button>
                )}
              </div>
            </div>
            <div className="jobdetailsMain-b2">
              <div className="jobdetailsMain-b2-m1">Highlights</div>
              <div className="jobdetailsMain-b2-m2Main">
                <Tooltip title={"Job Role / Category"} arrow>
                  <div
                    style={{
                      display: "flex",
                      columnGap: "8px",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <PersonIcon fontSize="small" style={{ color: "#424242" }} />
                    <div
                      className="jobdetailsMain-b2-m2"
                      style={{ cursor: "pointer" }}
                    >
                      {responseData?.role?.[0] === ""
                        ? "Not mentioned"
                        : responseData?.role?.[0] || "Not mentioned"}
                    </div>
                  </div>
                </Tooltip>
                <Tooltip title={"Experience"} arrow>
                  <div
                    style={{
                      display: "flex",
                      columnGap: "8px",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <WorkIcon fontSize="small" style={{ color: "#424242" }} />
                    <div className="jobdetailsMain-b2-m2">
                      {responseData?.experience || "Any"}
                    </div>
                  </div>
                </Tooltip>
                <Tooltip title={"Job Type"} arrow>
                  <div
                    style={{
                      display: "flex",
                      columnGap: "8px",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <SourceIcon fontSize="small" style={{ color: "#424242" }} />
                    <div className="jobdetailsMain-b2-m2">
                      {(() => {
                        if (responseData?.type === "H") return "Full Time";
                        else if (responseData?.type === "FL")
                          return "Freelance";
                        else if (responseData?.type === "C") return "Contract";
                        else if (responseData?.type === "C2H")
                          return "Contract to hire";
                        else return "N/A";
                      })()}
                    </div>
                  </div>
                </Tooltip>
                <Tooltip title={"Total Applicants"} arrow>
                  <div
                    style={{
                      display: "flex",
                      columnGap: "8px",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {/* <PeopleIcon fontSize="small" style={{ color: "#424242" }} /> */}
                    <div className="jobdetailsMain-b2-m2">
                      {/* {`${referData || 0} Applicants`}{" "} */}
                    </div>
                  </div>
                </Tooltip>
              </div>
            </div>
            {skills.length === 0 ? (
              <></>
            ) : (
              <div className="jobdetailsMain-b4">
                <div className="jobdetailsMain-b3-m1">Skills</div>
                <div className="jobdetailsMain-b4-m2">
                  {skills.map((item, index) => {
                    return <ChipJobDetails title={item} key={index} />;
                  })}
                </div>
              </div>
            )}

            {responseData?.description && (
              <div className="jobdetailsMain-b3">
                <div className="jobdetailsMain-b3-m1">About the Job</div>
                <div
                  id="htmlServer"
                  className="jobdetailsMain-b3-m2"
                  dangerouslySetInnerHTML={{
                    __html: Html(responseData?.description),
                  }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>
      {isOpen.isSignupOpen && (
        <SignupPopup isOpen={isOpen} setIsOpen={setIsOpen} />
      )}
      {isOpen.isOTPOpen && (
        <OtpVerify isOpen={isOpen} setIsOpen={setIsOpen} setToken={setToken} />
      )}
      {isOpen.isResumeOpen && (
        <ResumeUpload isOpen={isOpen} setIsOpen={setIsOpen} token={token} />
      )}
      {isOpen.isConfirm && (
        <ConfirmModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          responseData={responseData}
          id={id}
          getAllData={getAllData}
          apiJodApply={apiJodApply}
        />
      )}
      {isShow && <ShareUI isShow={isShow} setShow={setShow} />}
    </>
  );
};

export default Jobdetails;
